import React, {useState} from "react";
import AlertDialog from "../Components/Modals/AlertDialog";
import publicIp from "public-ip";
import Api from "../helpers/apiHelpers";
import {autocompleteCurrentPosition, getUsState} from "../helpers/LocationHelpers";
import {useDispatch, useSelector} from "react-redux";
import {setLocation} from "../redux/common/common.reducers";
import {states} from "../Constants/locations";
import {RootState, useAppDispatch} from "../redux/store";
import {getAddress} from "../redux/userProfile/userProfile.actions";

interface ICoords {
    latitude: string;
    longitude: string;
}

interface IPosition {
    coords: ICoords;
}

interface IState {
    label: "string",
    value: "string"
}

const withLocation = Component => (props: any) => {
    const dispatch = useAppDispatch();
    const location = useSelector((state: RootState) => state?.common.location);
    const isChanged = useSelector((state: RootState) => state?.common.sessionChanges);
    const user = useSelector((state: RootState) => state?.user);
    const [open, setOpen] = useState(false);

    const onConfirm = () => {
        autocompleteCurrentPosition()
            .then((res: IPosition) => (
                getUsState(res)
            ))
            .then((location?: IState) => {
                dispatch(setLocation(location?.value));
            })
            .catch(() => {
                getLocationFromProfile();
            });
    };

    const getLocationFromProfile = () => {
        dispatch(getAddress(user.userId))
            .then((address) => {
                dispatch(setLocation(address?.state || false));
            });
    };

    const getLocationWithPopup = async () => {
        const accessVal = localStorage.getItem("locationAccess");
        if (accessVal === "false") {
            dispatch(setLocation(false));
        } else {
            const ip = await publicIp.v4();
            if (!location && !isChanged) {await Api.getLocation(ip)
                .then((location: any) => {
                    localStorage.setItem("locationAccess", "true");
                    dispatch(setLocation(location));
                })
                .catch(() => {
                    navigator.permissions.query({name: "geolocation"})
                        .then(({state}) => {
                            if (state === "prompt") {
                                if (accessVal === "true") {
                                    onConfirm();
                                } else if (accessVal === null) {
                                    setOpen(true);
                                }
                            } else if (state === "granted") {
                                onConfirm();
                            } else {
                                getLocationFromProfile();
                            }
                        });
                });
            }
        }
    };

    return (
        <>
            <Component
                {...props}
                getLocation={getLocationWithPopup}
            />
            <AlertDialog
                open={open}
                setOpen={setOpen}
                onConfirm={onConfirm}
            />
        </>
    );
};

export default withLocation;
